import colorsys from 'colorsys';

export const getColorBrightness = (color: string) => {
  const {r, g, b} = colorsys.hexToRgb(color);

  return Math.round(
    (parseInt(r) * 299 + parseInt(g) * 587 + parseInt(b) * 114) / 1000,
  );
};
